<template>
  <div>
    <!-- <div style="background: #edeae7">
      <div class="title-bar">
        <img
          style="margin-top: -2px"
          src="../../assets/img/home-icon.png"
          alt=""
        />
        <span style="margin-left: 5px; color: #666666; font-size: 12px"
          >您的位置：</span
        >
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>{{ currentItemName }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div> -->
    <div class="main">
      <div class="newslist clearfix" :style="defSty">
        <div class="newsTab">
          <ul v-for="(tab, index) in tabs" :key="index">
            <li
              @click="changeList(index)"
              :class="{ liBackground: changeBackground == index }"
            >
              <img class="tabicon" :src=" changeBackground == index ? tab.sel_icon : tab.icon" alt="">
              <a>{{ tab.name }}</a>
            </li>
          </ul>
        </div>
        <div class="policy" v-if="policyShow">
          <ul v-for="(policy, index) in policyList" :key="index">
            <li class="clearfix1 cursor" @click="gotoDetail(policy)">
              <el-image fit="cover" class="img"  :src="policy.fileUrl ? policy.fileUrl : require('../../assets/img/zhengceicon.jpeg')" />
              <div class="content">
                <div class="htitlediv">
                  <div class="msgtitle">{{ policy.name }}</div>
                  <div class="time right">{{ policy.createTime }}</div>
                </div>
                
                <div class="htmlstr" v-html="policy.content"></div>
              </div>
            </li>
          </ul>
        </div>
        <div class="notice" v-if="noticeShow">
          <ul v-for="(notice, index) in noticeList" :key="index">
            <li class="clearfix1 cursor" @click="gotoDetail(notice)">
              <div class="content">
                <div class="htitlediv">
                  <div class="msgtitle">{{ notice.name }}</div>
                  <div class="time right">{{ notice.createTime }}</div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="block">
          <el-pagination
            layout="prev, pager, next"
            :total="total"
            :current-page="pageParam.pageNum"
            :page-size="pageParam.pageSize"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  selectPolicyAll,
  NoticeAll,
  standardAll,
} from '../../api/home/index.js'
import { mapMutations, mapState, mapGetters } from 'vuex'
export default {
  data() {
    return {
      total:0,
      defSty: {
        'min-height': `${document.documentElement.clientHeight - 394}px`,
      },
      policyShow: true,
      noticeShow: false,
      changeBackground: 0,
      currentItemName: '标准',
      tabs: [
        { name: '标准', id: 1,icon: require('../../assets/img/bzicon_def.png') ,sel_icon:require('../../assets/img/bzicon_sel.png')  },
        { name: '政策', id: 2 ,icon: require('../../assets/img/zcicon_def.png') ,sel_icon:require('../../assets/img/zcicon_sel.png') },
        { name: '公告', id: 3 ,icon: require('../../assets/img/ggicon_def.png') ,sel_icon:require('../../assets/img/ggicon_sel.png') },
      ],
      policyList: [],
      noticeList: [],
      pageParam: {
        pageNum: 1,
        pageSize: 10,
        platformId: ""
      },
    }
  },
  computed: {
    ...mapGetters(['resSchoolId']),
  },
  created() {
    this.changeBackground = this.$route.query.id - 1
    if (this.$route.query.id - 1 == 0) {
      let param = Object.assign({}, this.pageParam, { afficheType: 2 })
      this.getsStandard(param)
      this.noticeShow = true
      this.policyShow = false
      this.currentItemName = '标准'
    } else if (this.$route.query.id - 1 == 1) {
      let param = Object.assign({}, this.pageParam, { afficheType: 1 })
      this.getsSelectPolicy(param)
      this.noticeShow = false
      this.policyShow = true
      this.currentItemName = '政策'
    } else if (this.$route.query.id - 1 == 2) {
      let param = Object.assign({}, this.pageParam, { afficheType: 4,platformId:this.resSchoolId ? this.resSchoolId :'' })
      this.getsNotice(param)
      this.noticeShow = true
      this.policyShow = false
      this.currentItemName = '公告'
    }
  },
  methods: {
    getsStandard(param) {
      //标准
      standardAll(param)
        .then((res) => {
          if (res.status == 0) {
            this.noticeList = res.data
            this.total = res.page.total;
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getsSelectPolicy(param) {
      //政策
      selectPolicyAll(param)
        .then((res) => {
          if (res.status == 0) {
            this.policyList = res.data
            this.total = res.page.total;
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getsNotice(param) {
      //公告
      NoticeAll(param)
        .then((res) => {
          if (res.status == 0) {
            this.noticeList = res.data
            this.total = res.page.total;
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    changeList(index) {
      if (index == this.changeBackground) {
        return;
      }
      this.changeBackground = index
      if (index == 0) {
        this.noticeShow = true
        this.policyShow = false
        let param = Object.assign({}, this.pageParam, { afficheType: 2 })
        this.getsStandard(param)
        this.currentItemName = '标准'
      } else if (index == 1) {
        this.noticeShow = false
        this.policyShow = true
        let param = Object.assign({}, this.pageParam, { afficheType: 1 })
        this.getsSelectPolicy(param)
        this.currentItemName = '政策'
      } else if (index == 2) {
        this.noticeShow = true
        this.policyShow = false
        let param = Object.assign({}, this.pageParam, { afficheType: 4 ,platformId:this.resSchoolId ? this.resSchoolId :''})
        this.getsNotice(param)
        this.currentItemName = '公告'
      }
    },
    handleCurrentChange(page){
      this.pageParam.pageNum = page;
      if (this.changeBackground == 0) {
        this.noticeShow = true
        this.policyShow = false
        let param = Object.assign({}, this.pageParam, { afficheType: 2 })
        this.getsStandard(param)
        this.currentItemName = '标准'
      } else if (index == 1) {
        this.noticeShow = false
        this.policyShow = true
        let param = Object.assign({}, this.pageParam, { afficheType: 1 })
        this.getsSelectPolicy(param)
        this.currentItemName = '政策'
      } else if (index == 2) {
        this.noticeShow = true
        this.policyShow = false
        let param = Object.assign({}, this.pageParam, { afficheType: 4 ,platformId:this.resSchoolId ? this.resSchoolId :''})
        this.getsNotice(param)
        this.currentItemName = '公告'
      }
    },
    gotoDetail(item) {
      localStorage.setItem('item', JSON.stringify(item))
      this.$router.push({
        path: '/newsDetail',
        query: { type: this.changeBackground + 1, id: item.fid },
      })
    },
  },
}
</script>

<style scoped>
.cursor {
  cursor: pointer;
}
.title-bar {
  width: 1200px;
  margin: 0 auto;
  height: 36px;
  line-height: 36px;
  color: #666666;
  font-size: 12px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.clearfix1 {
  overflow: hidden;
}
.img{
  float: left;
  width: 150px;
  height: 84px;
}
.main {
  background-color: #f8f8f8;
  width: 100%;
  height: auto;
}
.newslist {
  width: 1200px;
  /* background-color: #ffffff; */
  /* padding: 30px 40px 60px 40px; */
  margin: 0 auto;
}
.newsTab {
  /* float: left; */
  display: flex;
  justify-content: flex-end;
  background-color: white;
  margin-top: 20px;
}
.htitlediv{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.newsTab li {
  width: 150px;
  height: 50px;
  line-height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.newsTab li a {
  display: inline-block;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}
.newsTab li img{
  width: 16px;
  height: 16px;
  margin-right: 10px;
}
.policy,
.notice {
  /* margin-left: 290px; */
  margin-top: 10px;
  padding: 50px 40px;
  background-color: white;
}
.policy ul,
.notice ul {
  font-size: 0px;
  margin-bottom: 20px;
  border-bottom: 1px dashed #e6e6e6;
}
.policy li{
  margin-bottom: 20px;
}
.policy li img {
  float: left;
  width: 150px;
  max-width: 150px;
  height: 84px;
}
.notice li .msgtitle,
.policy li .msgtitle {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  line-height: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.policy li .msgtitle{
  padding-left: 18px;
}
.notice li .msgtitle:hover,
.policy li .msgtitle:hover{
  color: #0082F0;
}
.notice li .time,
.policy li .time {
  font-size: 14px;
  font-family: Helvetica Light;
  margin: 8px 0 0px 0;
  display: block;
  font-weight: 400;
  color: #666666;
  line-height: 14px;
}
.policy li .htmlstr {
  height: 48px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 22px;
  overflow: hidden;
  padding-top: 20px;
  padding-left: 20px;
}
.liBackground a {
  color: #0082F0 !important;
}
</style>
